module.exports = __webpack_public_path__ + "img/check2-active.753447fd.svg";